import { enableProdMode, LOCALE_ID, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { withInterceptorsFromDi, provideHttpClient, withXhr } from '@angular/common/http';
import { Title, bootstrapApplication } from '@angular/platform-browser';
import { provideRouter, withRouterConfig } from '@angular/router';
import { provideServiceWorker } from '@angular/service-worker';

import { registerLocaleData } from '@angular/common';
import localeEn from '@angular/common/locales/en';
import localeNor from '@angular/common/locales/nb';
import localeNorExtra from '@angular/common/locales/extra/nb';

import { enableAkitaProdMode } from '@datorama/akita';
import { AkitaNgDevtools } from '@datorama/akita-ngdevtools';

import { environment } from '@gan/core/util-environment';

import { AppComponent } from './app/app.component';
import { ROUTES } from './app/app-routes';

import { provideTitle } from '@gan/shared/ui-title';
import { provideLucidIcons } from '@gan/shared/ui-icon';
import { provideUser } from '@gan/common/data-user';
import { provideApplicationVersion } from '@gan/core/feature-application-version';
import { provideLocalStorage } from '@gan/core/util-local-storage';
import { provideAuth } from '@gan/common/feature-auth';
import { LanguageService, provideLanguage } from '@gan/core/feature-language';
import { provideDateTimeHelper } from '@gan/core/util-date-time-helper';

if (environment.production) {
  enableProdMode();
}

registerLocaleData(localeEn, 'en');
registerLocaleData(localeNor, 'no', localeNorExtra);

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),
    provideDateTimeHelper(),
    provideLanguage(),
    provideApplicationVersion(),
    provideLocalStorage(),
    provideUser(),
    provideAuth(),
    provideLucidIcons(),
    // Angular 21's default; 22's 'always' would also give child routes their parents' params and data
    provideRouter(ROUTES, withRouterConfig({ paramsInheritanceStrategy: 'emptyOnly' })),
    ...(environment.production ? [] : [importProvidersFrom(AkitaNgDevtools.forRoot())]),
    provideTitle(),
    provideServiceWorker('ngsw-worker.js', {
      enabled: !environment.APP_URL.includes('localhost'),
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:5000',
    }),
    Title,
    {
      provide: LOCALE_ID,
      useFactory: (storage: LanguageService) => storage.getLang(),
      deps: [LanguageService],
    },
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { subscriptSizing: 'dynamic' } },
    provideAnimations(),
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
  ],
}).catch((err) => console.error(err));

// Akita
if (environment.production) {
  enableAkitaProdMode();
}
